import { api } from "./api";

export interface ProviderInfo {
  id: string;
  org_id: string;
  client_id: string | null;
  name: string;
  provider_type: string;
  adapter_type: string;
  default_model: string | null;
  status: string;
  created_at: string;
}

export interface MyModelInfo {
  provider_id: string;
  provider_name: string;
  adapter_type: string;
  provider_type: string;
  models: string[];
}

export const providerService = {
  myModels: () => api.get<MyModelInfo[]>("/my-models"),

  list: (orgId: string) =>
    api.get<ProviderInfo[]>(`/orgs/${orgId}/providers`),

  createApiProxy: (orgId: string, data: {
    name: string; adapter_type: string; base_url: string; api_key: string; default_model?: string;
  }) => api.post<ProviderInfo>(`/orgs/${orgId}/providers`, data),

  update: (orgId: string, pid: string, data: {
    name?: string; base_url?: string; api_key?: string; default_model?: string;
  }) => api.put<ProviderInfo>(`/orgs/${orgId}/providers/${pid}`, data),

  delete: (orgId: string, pid: string) =>
    api.delete(`/orgs/${orgId}/providers/${pid}`),
};
